import React from 'react';

import ReactModal from 'react-modal';

import BnplFooter from './BnplFooter';

import closeIcon from '../../assets/images/close.svg';
import tenantConfig from '../../config';

const BnplModal = ({ openModal, closeModal, children, setActiveModal, setOpenModal }) => {
  return (
    <ReactModal
      isOpen={openModal}
      className="field-modal bnpl-modal modal-custom-styles"
      onRequestClose={closeModal}
    >
      <div className="bnpl-modal-header">
        <img className="logo-img" src={tenantConfig.headerLogo} alt="logo" />
        <img className="close-icon" onClick={closeModal} src={closeIcon} alt="close-icon" />
      </div>
      {children}
      <div className="bnpl-footer">
        <BnplFooter setActiveModal={setActiveModal} setOpenModal={setOpenModal} />
      </div>
    </ReactModal>
  );
};

export default BnplModal;
